var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0001 2.39058C5.97711 2.39058 1.89054 6.47715 1.89054 11.5002C1.89054 16.5234 5.97711 20.61 11.0001 20.61C16.0232 20.61 20.1097 16.5234 20.1097 11.5002C20.1097 6.47715 16.0232 2.39058 11.0001 2.39058ZM0 11.5002C0 5.43484 4.93465 0.500183 11 0.500183C17.0653 0.500183 22 5.43484 22 11.5002C22 17.5658 17.0653 22.5004 11 22.5004C4.93465 22.5004 0 17.5658 0 11.5002Z",
    fill: "#836B55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.835 18.708C11.4336 18.708 11.9185 18.2229 11.9185 17.6246C11.9185 17.026 11.4336 16.541 10.835 16.541C10.2364 16.541 9.75146 17.026 9.75146 17.6246C9.75146 18.2229 10.2364 18.708 10.835 18.708Z",
    fill: "#836B55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1285 13.9755C12.105 14.5165 11.6285 14.9368 11.064 14.9148C10.4992 14.8923 10.0602 14.4356 10.0834 13.8946C10.1003 13.5051 10.201 12.9803 10.4685 12.4344C10.773 11.8122 11.2415 11.3147 11.9028 11.0288C12.9656 10.5698 13.6644 9.67258 13.6644 9.03375C13.6644 7.68009 12.5189 6.58294 11.1058 6.58294C9.69302 6.58294 8.54749 7.68009 8.54749 9.03375C8.54749 9.57503 8.08962 10.0139 7.52436 10.0139C6.95909 10.0139 6.50098 9.57503 6.50098 9.03375C6.50098 6.5973 8.56273 4.62219 11.1058 4.62219C13.6492 4.62219 15.7109 6.5973 15.7109 9.03375C15.7109 10.5 14.4972 12.059 12.7443 12.8162C12.5728 12.8901 12.4332 13.0387 12.3213 13.2669C12.2458 13.421 12.1914 13.5966 12.1573 13.7736C12.1372 13.8774 12.1294 13.9511 12.1285 13.9755Z",
    fill: "#836B55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQmark);
export default __webpack_public_path__ + "static/media/Qmark.61ba281f9100024384558da25d0728fe.svg";
export { ForwardRef as ReactComponent };